import AxiosControl from '../../context/axios/AxiosControl'
const Axios = AxiosControl()

export const getPassTypesByClub = (club) => async (dispatch) => {
    dispatch({
        type: 'PASSTYPE_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/passType/getPassTypesByClub/'+ club, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'PASSTYPE_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'PASSTYPE_NOT_LOADING'
        })
    }
}

export const getAvailablePassTypesByClub = (club) => async (dispatch) => {
    dispatch({
        type: 'PASSTYPE_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/passType/getAvailablePassTypesByClub/'+ club, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'PASSTYPE_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'PASSTYPE_NOT_LOADING'
        })
    }
}

export const getPassType = (passTypeId) => async (dispatch) => {
    dispatch({
        type: 'PASSTYPE_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/passType/getPassType/'+ passTypeId, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'PASSTYPE_GET_SUCCESS',
                payload: data?.passType
            })
        }
    } catch (error) {
        dispatch({
            type: 'PASSTYPE_NOT_LOADING'
        })
    }
}

export const getPublicPassTypesByClub = (club) => async (dispatch) => {
    dispatch({
        type: 'PASSTYPE_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/passType/getPublicPassTypesByClub/'+ club, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            // Filtrar los tipos de abono con visibleMarketplace !== false
            const filteredPassTypes = data.passTypesMarket.filter(passType => passType.visibleMarketplace !== false);
            
            dispatch({
                type: 'PASSTYPE_GETALL_SUCCESS',
                payload: {...data, passTypes: filteredPassTypes, passTypesMarket: undefined}
            })
        }
    } catch (error) {
        dispatch({
            type: 'PASSTYPE_NOT_LOADING'
        })
    }
}

export const getPassTypePublicByUrl = ({url, club}) => async (dispatch) => {
    dispatch({
        type: 'PASSTYPE_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/passType/public/getPublicPassTypeByUrl/'+ url +'/'+ club)
        if (status === 200) {
            dispatch({
                type: 'PASSTYPE_GET_SUCCESS',
                payload: data?.passTypeMarket
            })
        }
    } catch (error) {
        dispatch({
            type: 'PASSTYPE_NOT_LOADING'
        })
    }
}

export const addPassType = (passTypeData) => async (dispatch) => {
    dispatch({
        type: 'PASSTYPE_LOADING'
    })
    try {
        // Asegurarnos de que visibleMarketplace mantiene su valor, incluso si es false
        // Explícitamente hacemos una copia para asegurarnos de que no se modifica
        const dataToSend = {
            ...passTypeData,
            visibleMarketplace: passTypeData.visibleMarketplace
        };
        
        // Subida de la miniatura
        if(dataToSend.image !== null && dataToSend.image !== undefined && dataToSend.image !== '' && typeof dataToSend.image !== 'string'){
            let formData = new FormData()
            formData.append('image', dataToSend.image)

            const {data} = await Axios.post(process.env.REACT_APP_DB_ADDRESS + '/api/upload/uploadimage', formData, {
                headers: {
                    'Content-Type': `multipart/form-data`,
                    auth: sessionStorage.getItem('jwt')
                }
            })
            dataToSend.image = data
        } else {
            dataToSend.image = null
        }

        // Subida del anverso de la plantilla para impresión
        if(dataToSend.obverseTemplate !== null && dataToSend.obverseTemplate !== undefined && dataToSend.obverseTemplate !== '' && typeof dataToSend.obverseTemplate !== 'string'){
            let formData = new FormData()
            formData.append('image', dataToSend.obverseTemplate)

            const {data} = await Axios.post(process.env.REACT_APP_DB_ADDRESS + '/api/upload/uploadimage', formData, {
                headers: {
                    'Content-Type': `multipart/form-data`,
                    auth: sessionStorage.getItem('jwt')
                }
            })
            dataToSend.obverseTemplate = data
        } else {
            dataToSend.obverseTemplate = null
        }

        // Subida del reverso de la plantilla para impresión
        if(dataToSend.reverseTemplate !== null && dataToSend.reverseTemplate !== undefined && dataToSend.reverseTemplate !== '' && typeof dataToSend.reverseTemplate !== 'string'){
            let formData = new FormData()
            formData.append('image', dataToSend.reverseTemplate)

            const {data} = await Axios.post(process.env.REACT_APP_DB_ADDRESS + '/api/upload/uploadimage', formData, {
                headers: {
                    'Content-Type': `multipart/form-data`,
                    auth: sessionStorage.getItem('jwt')
                }
            })
            dataToSend.reverseTemplate = data
        } else {
            dataToSend.reverseTemplate = null
        }
        
        // Forzamos el valor de visibleMarketplace en la petición
        // para asegurarnos de que se envía correctamente
        console.log("Enviando visibleMarketplace: ", dataToSend.visibleMarketplace);

        const { data, status} = await Axios.post('/api/passType/register', dataToSend, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            // Verificamos si el backend devolvió el valor correcto
            console.log("Valor devuelto de visibleMarketplace:", data?.passType?.visibleMarketplace);
            
            dispatch({
                type: 'PASSTYPE_ADD_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'PASSTYPE_NOT_LOADING'
        })
    }
}

export const editPassType = (passTypeId, passTypeData) => async (dispatch) => {
    dispatch({
        type: 'PASSTYPE_LOADING'
    })
    try {
        // Asegurarnos de que visibleMarketplace mantiene su valor, incluso si es false
        // Explícitamente hacemos una copia para asegurarnos de que no se modifica
        const dataToSend = {
            ...passTypeData,
            visibleMarketplace: passTypeData.visibleMarketplace
        };
        
        // Subida de la miniatura
        if(dataToSend.image !== null && dataToSend.image !== undefined && dataToSend.image !== '' && typeof dataToSend.image !== 'string'){
            let formData = new FormData()
            formData.append('image', dataToSend.image)

            const {data} = await Axios.post(process.env.REACT_APP_DB_ADDRESS + '/api/upload/uploadimage', formData, {
                headers: {
                    'Content-Type': `multipart/form-data`,
                    auth: sessionStorage.getItem('jwt')
                }
            })
            dataToSend.image = data
        } else {
            dataToSend.image = null
        }

        // Subida del anverso de la plantilla para impresión
        if(dataToSend.obverseTemplate !== null && dataToSend.obverseTemplate !== undefined && dataToSend.obverseTemplate !== '' && typeof dataToSend.obverseTemplate !== 'string'){
            let formData = new FormData()
            formData.append('image', dataToSend.obverseTemplate)

            const {data} = await Axios.post(process.env.REACT_APP_DB_ADDRESS + '/api/upload/uploadimage', formData, {
                headers: {
                    'Content-Type': `multipart/form-data`,
                    auth: sessionStorage.getItem('jwt')
                }
            })
            dataToSend.obverseTemplate = data
        } else {
            dataToSend.obverseTemplate = null
        }

        // Subida del reverso de la plantilla para impresión
        if(dataToSend.reverseTemplate !== null && dataToSend.reverseTemplate !== undefined && dataToSend.reverseTemplate !== '' && typeof dataToSend.reverseTemplate !== 'string'){
            let formData = new FormData()
            formData.append('image', dataToSend.reverseTemplate)

            const {data} = await Axios.post(process.env.REACT_APP_DB_ADDRESS + '/api/upload/uploadimage', formData, {
                headers: {
                    'Content-Type': `multipart/form-data`,
                    auth: sessionStorage.getItem('jwt')
                }
            })
            dataToSend.reverseTemplate = data
        } else {
            dataToSend.reverseTemplate = null
        }
        
        // Forzamos el valor de visibleMarketplace en la petición
        // para asegurarnos de que se envía correctamente
        console.log("Enviando visibleMarketplace:", dataToSend.visibleMarketplace);

        const { data, status} = await Axios.post('/api/passType/edit/' + passTypeId, dataToSend, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            // Verificamos si el backend devolvió el valor correcto
            console.log("Valor devuelto de visibleMarketplace:", data?.passType?.visibleMarketplace);
            
            dispatch({
                type: 'PASSTYPE_ADD_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'PASSTYPE_NOT_LOADING'
        })
    }
}

export const deletePassType = (passTypeId) => async (dispatch) => {
    dispatch({
        type: 'PASSTYPE_LOADING'
    })
    try {
        const { data, status } = await Axios.delete('/api/passType/delete/'+ passTypeId, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'PASSTYPE_EDIT_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'PASSTYPE_NOT_LOADING'
        })
    }
}